export interface UserDataFormValues {
  name: string;
  surname: string;
  health_professional: boolean;
  id_profession: number | null;
  id_registration_type: number | null;
  registration_number: string | null;
  document_number: string | null;
  signature: File | null;
}

export const USER_DATA_INITIAL_VALUES: UserDataFormValues = {
  name: "",
  surname: "",
  health_professional: false,
  id_profession: null,
  id_registration_type: null,
  registration_number: "",
  document_number: "",
  signature: null,
};

export const toggleHealthProfessional = (
  values: UserDataFormValues,
): UserDataFormValues => {
  const healthProfessional = !values.health_professional;

  if (healthProfessional) {
    return {
      ...values,
      health_professional: true,
    };
  }

  return {
    ...values,
    health_professional: false,
    id_profession: null,
    id_registration_type: null,
    registration_number: "",
    document_number: "",
    signature: null,
  };
};
